<div class="container">
  <div class="header">
    <div class="tab-icon">
      <h2>{{ PositionLabels.Title }}</h2>
      <emerald-icon [icon]="'open_in_new'" [color]="priority.grey" [fontsizeInRem]="fontSize_opentab"
        (click)="navigateToPositionsList()"></emerald-icon>
    </div>
    <emerald-menu [opened]="opened" [position]="'bottom_end'" [targetElement]="navTemplate"
      [menuTemplate]="menuTemplate" (openChange)="opened = $event"></emerald-menu>
    <ng-template #navTemplate>
      <emerald-button [label]="'Filter'" [size]="'Small'" [type]="'Secondary'" [icon]="'filter_list'"
        [iconPosition]="'Left'" (onClick)="this.opened = !this.opened"></emerald-button>
    </ng-template>
    <ng-template #menuTemplate>
      <app-positions-filter [rowData]="allPositions" (filterApplied)="onFilter($event)"></app-positions-filter>
    </ng-template>
  </div>

  <div class="visual">
    <div class="donut">
      <svg viewBox="0 0 72 72" class="donut-svg" aria-hidden="true">
        <circle class="donut-track" cx="36" cy="36" r="28"></circle>
        <circle
          *ngFor="let seg of donutSegments"
          class="donut-segment"
          cx="36"
          cy="36"
          r="28"
          [attr.stroke]="seg.color"
          [attr.stroke-dasharray]="seg.dashArray"
          [attr.stroke-dashoffset]="seg.dashOffset"
        ></circle>
      </svg>
      <div class="donut-center">
        <span class="donut-value">{{ totalCount }}</span>
        <span class="donut-label">TOTAL</span>
      </div>
    </div>
    <div class="breakdown">
      <div class="bd-tile" [style.border-left-color]="positionColors.open">
        <span class="bd-value" [style.color]="positionColors.open">{{ openCount }}</span>
        <span class="bd-label">{{ PositionLabels.Open_Positions }}</span>
      </div>
      <div class="bd-tile" [style.border-left-color]="positionColors.onHold">
        <span class="bd-value" [style.color]="positionColors.onHold">{{ onHoldCount }}</span>
        <span class="bd-label">{{ PositionLabels.On_Hold_Positions }}</span>
      </div>
      <div class="bd-tile" [style.border-left-color]="positionColors.closed">
        <span class="bd-value" [style.color]="positionColors.closed">{{ closeCount }}</span>
        <span class="bd-label">{{ PositionLabels.Closed_Positions }}</span>
      </div>
    </div>
  </div>
</div>